import React from "react";

export default function PortfolioPageShell({
  tag,
  title,
  subtitle,
  description,
  children,
  maxWidth = "max-w-7xl",
}) {
  return (
    <div className="relative bg-[#F5F5F0] min-h-screen overflow-hidden">
      <div className="portfolio-dots" aria-hidden="true" />

      <div className={`relative ${maxWidth} mx-auto px-4 md:px-8 pt-28 pb-24`}>
        <div className="mb-10">
          {tag && (
            <p className="font-arcade text-base text-[#15803D] uppercase mb-3 tracking-widest">
              &gt; {tag}
            </p>
          )}
          {title && (
            <h1 className="font-pixel text-3xl md:text-5xl text-[#0A0A0A] leading-tight">
              {title}
            </h1>
          )}
          {subtitle && (
            <p className="font-arcade text-lg md:text-xl text-[#BE185D] uppercase tracking-wider mt-4">
              {subtitle}
            </p>
          )}
          {description && (
            <p className="font-terminal text-sm md:text-base text-[#0A0A0A]/70 leading-relaxed mt-3 max-w-3xl">
              {description}
            </p>
          )}
        </div>

        {children}
      </div>
    </div>
  );
}
